import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    data: {},
    instagram: {},
    cities: []
  },
  actions: {
    async fetch({state, commit}) {
      const { data } = await axios.get(`${process.env.KIRBY_ENDPOINT}/api/site.php`)

      commit('receiveData', data)
    },
    async fetchInstagram({state, commit}) {
      const { data } = await axios.get(`${process.env.KIRBY_ENDPOINT}/api/instagram.php`)

      commit('receiveInstagram', data)
    },
    async fetchCities({state, commit}) {
      const { data } = await axios.get(`${process.env.KIRBY_ENDPOINT}/api/cities.php`)

      commit('receiveCities', data)
    }
  },
  mutations: {
    receiveData(state, data) {
      state.data = data
    },
    receiveInstagram(state, data) {
      state.instagram = data
    },
    receiveCities(state, data) {
      state.cities = data
    }
  },
  getters: {
    currentArtist(state) {
      return state.data.current_artist
    },
    about(state) {
      return state.data.about
    },
    excerpt(state) {
      return state.data.excerpt
    },
    supporters(state) {
      return state.data.supporters
    },
    instagramTags(state) {
      const excludes = (state.data.exclude_tags || '')
        .split('\n')
        .map(tag => tag.replace('#', '').toLowerCase())

      return _.filter(_.uniq(_.flatten(_.map(_.toArray(state.instagram), 'tags'))), tag => {
        return !excludes.includes(tag.toLowerCase())
      })
    },
    homeGallery(state, getters) {
      return state.data.gallery && state.data.gallery.length && state.data.gallery
    },
    instagramGallery(state, getters, rootState, rootGetters) {
      const media = _.toArray(state.instagram)

      const excludes = (state.data.exclude_home || '')
        .split('\n')
        .map(tag => tag.replace('#', '').toLowerCase())

      const filteredMedia = _.filter(media, item =>
        _.intersection(item.tags.map(tag => tag.toLowerCase()), excludes).length === 0
      )

      let currentArtist = rootGetters['artists/currentArtist']

      if(currentArtist) {
        const currentMedia = _.filter(filteredMedia, item => {
          if(currentArtist) {
            if(currentArtist.hashtag) {
              return item.tags.map(tag => tag.toLowerCase()).includes(currentArtist.hashtag.replace('#', '').toLowerCase())
            } else {
              return item.caption.text.match(`@${currentArtist.instagram}`)
            }
          }
        })

        const results = _.map(_.reverse(currentMedia), item => {
          return {
            image: _.get(item, 'images.standard_resolution.url'),
            video: _.get(item, 'videos.standard_resolution.url')
          }
        })

        return results
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/site.js